<template>
  <tr class="is-package-header">
    <td class="align-middle p-2">
      <d-badge
        theme="dark"
        :outline="true"
        class="mr-2">
        {{ $t('service.isPackage') }}
      </d-badge>

      {{ servicePackageData.group_name }}
    </td>

    <td class="align-middle pt-2">
     <validation-provider
        v-if="!readOnly"
        rules="required|min_value:1"
        :name="'service-package-amount-' + servicePackageID"
        v-slot="{ errors }">
        <d-input-group>
          <d-input
            :min="1"
            :state="errors.length ? 'invalid' : null"
            v-model="qty"
            @input="servicesFromPackagePricesUpdateDueQtyChange(servicePackageID)"
            type="number" />
          <d-input-group-text slot="append">{{ $t('ui.piecesAbbr') }}</d-input-group-text>
        </d-input-group>
      </validation-provider>
      <template v-else>
        {{ qty }} {{ $t('ui.piecesAbbr') }}
      </template>

      <small
        v-if="!userIsCustomer && parseInt(qty, 10) != $parent.$parent.$parent.productsData[productIndex].count"
        class="text-danger cursor-pointer"
        @click="setServicePackageAmountToProductAmount()">
        {{ $t('ui.productsGenitive') }}: {{ $parent.$parent.$parent.productsData[productIndex].count }} {{ $t('ui.piecesAbbr') }}
      </small>
    </td>

    <td
      :hidden="isIndent && isOffer"
      class="align-middle pt-2">
    </td>

    <td
      :hidden="isIndent && isOffer"
      class="align-middle pt-2">
    </td>

    <td
      :hidden="isIndent && isOffer"
      class="align-middle pt-2">
    </td>

    <td
      v-if="!readOnly"
      class="align-middle pt-2">
      <d-button
        size="sm"
        outline
        @click.prevent="removeServicePackage"
        theme="danger">
        {{ $t('ui.delete') }}
      </d-button>
    </td>
  </tr>
</template>

<script>
import CustomerPanel from './../../mixins/CustomerPanel.vue';

export default {
  name: 'order-creator-service-package',
  mixins: [
    CustomerPanel
  ],
  props: [
    'isIndent',
    'isOffer',
    'readOnly',
    'productIndex',
    'servicePackageID',
    'servicePackages'
  ],
  computed: {
    servicePackageData () {
      let packageData = this.servicePackages.filter(pkg => pkg.id === this.servicePackageID);

      if (packageData && packageData[0]) {
        return packageData[0];
      }

      return {};
    }
  },
  data () {
    return {
      qty: null
    };
  },
  mounted () {
    this.qty = this.servicePackageData.quantity;
  },
  methods: {
    setServicePackageAmountToProductAmount () {
      this.qty = this.$parent.$parent.$parent.productsData[this.productIndex].count;
      this.servicesFromPackagePricesUpdateDueQtyChange();
    },
    servicesFromPackagePricesUpdateDueQtyChange () {
      this.$bus.$emit('order-update-service-qty-from-package', this.servicePackageID, this.qty);
      this.$bus.$emit('order-update-service-package-qty-in-product', {
        productIndex: this.productIndex,
        packageID: this.servicePackageData.id,
        qty: this.qty
      });
    },
    removeServicePackage () {
      if (this.servicePackageData.id) {
        this.$bus.$emit('order-remove-service-package-from-product', {
          productIndex: this.productIndex,
          packageID: this.servicePackageData.id
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.is-package-header > td {
  background: rgba(255, 180, 0, 0.25);
  border-top: 2px solid rgba(255, 180, 0, 1);
}

.is-package-header > td:first-child {
  border-left: 2px solid rgba(255, 180, 0, 1);
}

.is-package-header > td:last-child {
  border-right: 2px solid rgba(255, 180, 0, 1);
}
</style>
